<template>
  <b-modal
    id="delete-licenses-modal"
    scrollable
    header-bg-variant="danger"
    header-text-variant="white"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
  >
    <div>
      Estás por liberar {{ licenses && licenses.length > 1 ? 'las licencias' : 'la licencia' }}:
      <ul class="release-licenses-list" v-if="licenses && licenses.length > 0">
        <li class="release-licenses-item" v-for="license in licenses" :key="license.id">
          <div class="license-info">
            <div class="license-id">{{license.id}} <i class="fas fa-id-badge"></i></div>
            <div><p class="license-info-tag">Usuario:</p> {{ license.user.id }} - {{license.user.name}}</div>
            <div><p class="license-info-tag">Dipositivo: </p> {{ license.device.id }} - {{license.device.name}}</div>
            <div><p class="license-info-tag">UUID: </p>{{license.device.uuid}}</div>
            <div class="small"><p class="license-info-tag"> Fecha de asignación: </p>{{ dateFormat(license.acquiredDate) }}</div>
          </div>
        </li>
      </ul>
      <p>
      Esta acción realiza un cambio de estado del dispositivo a 'inactivo', marca la licencia como 'inactiva',
      y además, establece la fecha actual como fecha de liberación de la licencia.
      </p>
      <div class="release-action-confirm">
        Favor de marca la casilla para confirmar
        <b-checkbox v-model="deleteLicensesConfirm">Sí, estoy seguro</b-checkbox>
      </div>
    </div>
    <template v-slot:modal-title>
      <div class="inline">
        <i class="fas fa-dizzy"></i>
        Liberación de licencias
      </div>
    </template>
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeDeleteLicensesModal">
        Cancelar
      </b-button>
      <b-button variant="danger" :disabled="!deleteLicensesConfirm" @click="deleteLicenses(licenses)">
        Liberar
      </b-button>
    </template>
  </b-modal>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { License } from '@/types/catalogs/Licenses'
import moment from 'moment'
import CatalogsService from '@/services/CatalogsService'

@Component({
  name: 'ReleaseLicensesModal'
})
export default class ReleaseLicensesModal extends Vue {
  @Prop({ required: true })
  licenses: License[]

  @Prop({ required: false, default: false })
  fromAdminLicensesList: boolean

  deleteLicensesConfirm: boolean = false

  /**
   * Calls the DELETE function for every license on the list
   * that receives as parameter, and display a toast for each promise resolved
   *
   * @param licenses to release (delete)
   */
  async deleteLicenses (licenses: License[]) {
    let licensesReleased: Promise<License>[] = []
    licenses.forEach(license => {
      let request = CatalogsService.deleteLicense(license.id)
      licensesReleased.push(request)
      request
        .then((response) => {
          let licenseResponse = `La licencia: ${license.id} - usuario: ${license.user.name} - dispositivo: ${license.device.name}`
          this.$bvToast.toast(`${licenseResponse} ha sido liberada`, {
            title: 'Liberación exitosa',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            solid: true,
            autoHideDelay: 5000
          })
        })
        .catch((error) => {
          // Manage current and future error format
          let dataError = error.response.data
          let errors = []
          if (dataError.errors) {
            dataError.errors.forEach((e: any) => {
              errors.push(e.description)
            })
          } else {
            errors.push(dataError.description ? dataError.description : error.response)
          }
          let licenseResponse = `La licencia: ${license.id} - usuario: ${license.user.name} - dispositivo: ${license.device.name}`
          this.$bvToast.toast(`${licenseResponse} no se ha podido liberar. ${errors.join(', ')}`, {
            title: 'Error en la liberación',
            variant: 'danger',
            toaster: 'b-toaster-top-left',
            solid: true,
            autoHideDelay: 5000
          })
        })
    })
    await Promise.allSettled(licensesReleased)
      .finally(() => {
        if (this.fromAdminLicensesList) {
          this.$emit('update-licenses-list', true)
        } else {
          this.$emit('update-licenses-list', false)
        }
      })
    this.closeDeleteLicensesModal()
  }

  /**
   * Hides modal for delete licenses
   * and turn off the confirmation flag
   */
  closeDeleteLicensesModal () {
    this.deleteLicensesConfirm = false
    this.$bvModal.hide('delete-licenses-modal')
  }

  /**
   * Generates the iso date format
   *
   * @param date to format
   * @returns ISO 8601 format date
   */
  dateFormat (date?: Date) {
    return date ? moment(date).format('DD/MM/YYYY').toString() : '- -/- -/- - - -'
  }
}
</script>

<style lang="scss" scoped>

$gray-200: #e9ecef !default;

// Styles for delete licenses modal
.release-licenses-list {
  padding: 0.5em 0 0 0;
  margin-bottom: 0;

  .release-licenses-item {
    list-style-type: none;
    padding: 0.5em;
    box-shadow: -5px 0 1px -1px #000;
    border-radius: 0 10px 10px 0;
    margin-bottom: 0.5em;
    background-color: $gray-200;

    .license-info {
      font-weight: normal;

      .license-info-tag {
        font-weight: bold;
        display: inline;
      }
      .license-id {
        margin: 0;
        float: right;
        padding-right: 0.25em;
        font-size: 1.5em;
        font-weight: bold;
      }
    }
  }
}
</style>
